type VasBlockReducer = {
  [id: string]: {
    opened: boolean;
    showAgree: boolean;
  };
};

const initialState: VasBlockReducer = {};

type VasSetOpenedAction = {
  type: "VAS_SET_OPENED";
  payload: {
    id: string;
    opened: boolean;
  };
};

type VasSetShowAgreeAction = {
  type: "VAS_SET_SHOW_AGREE";
  payload: {
    id: string;
    showAgree: boolean;
  };
};

type ResetAction = {
  type: "RESET" | "VAS_RESET";
};

type VasBlockReducerActions =
  | VasSetOpenedAction
  | VasSetShowAgreeAction
  | ResetAction;

export const vasBlockReducer = (
  state: VasBlockReducer = initialState,
  action: VasBlockReducerActions
) => {
  switch (action.type) {
    case "VAS_SET_OPENED": {
      const { opened, id } = action.payload;
      return {
        ...state,
        [id]: {
          ...state[id],
          opened,
        },
      };
    }
    case "VAS_SET_SHOW_AGREE": {
      const { showAgree, id } = action.payload;
      return {
        ...state,
        [id]: {
          ...state[id],
          showAgree,
        },
      };
    }
    case "RESET":
    case "VAS_RESET": {
      return { ...initialState };
    }
    default:
      return state;
  }
};
